
import React,{useEffect, useState,} from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Grid, Button } from 'semantic-ui-react';
import './resource_master.css';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import axios from 'axios';  


import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { port } from '../../../services/auth-service/authService';

import { baseUrl } from "../../../services/common/credentials";


import FilesConsolidation from '../../process/etl/consolidation'


var local_host = baseUrl + port;


const columns = [
  { id: 'action_id', label: 'Action_id', minWidth: 10},
  { id: 'action_name', label: 'Action_name',minWidth: 10 },
  {
    id: 'action_description',
    label: 'Action_description',
    minWidth: 10
  },
  {
    id: 'action_details',
    label: 'Action_details',
    minWidth: 10
  },
  {
    id: 'restapi_address',
    label: 'Restapi_address',
    minWidth: 10
  },
  {
    id: 'action_category',
    label: 'Action_category',
    minWidth: 10
  },
  {
    id: 'task',
    label: 'Task',
    minWidth: 10
  },
  {
    id: 'actions',
    label: 'Actions',
    minWidth: 10
  },
];

const columns3 = [
  { id: 'task_id', label: 'Task_id', minWidth: 10},
  { id: 'task_name', label: 'Task_name',minWidth: 10 },
  {
    id: 'task_description',
    label: 'Task_description',
    minWidth: 10
  },
  {
    id: 'task_category',
    label: 'Task_category',
    minWidth: 10
  },
  
  {
    id: 'job',
    label: 'Job',
    minWidth: 10
  },
  {
    id: 'actions',
    label: 'Actions',
    minWidth: 10
  },
];

const columns2 = [
  { id: 'job_id', label: 'Job_id', minWidth: 15},
  { id: 'job_name', label: 'Job_name',minWidth: 15 },
  {
    id: 'job_description',
    label: 'Job_description',
    minWidth: 15
  },
  {
    id: 'job_category',
    label: 'Job_category',
    minWidth: 15
  },
  {
    id: 'process',
    label: 'Process',
    minWidth: 15
  },
  {
    id: 'actions',
    label: 'Actions',
    minWidth: 15
  },

];





const StickyHeadTable = ({data}) => {
  const [page, setPage] = useState(0);
  const [rowdata, setRowdata] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formCreate, setFormCreate] = useState(true);
  const [formValues, setFormValues] = useState({
  action_id: "",action_name: "",action_category: "",action_description: "",action_details: "",restapi_address: "",task: "" })

  let handleChange = (e) => {
      setFormValues({
        ...formValues,
        [e.target.name]: e.target.value
        })
    }
  
    const makeapicall = async (url) => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log('data'+data);
        setRowdata(data); 
        
      }
      catch (e) {
        console.log(e);
     
      }
    }
  
  let handleSubmit = (event) => {
      event.preventDefault();
      let url;
      if(formCreate == true){
        url = local_host + `/api/v2/user_modules/create_actions/`;
      }else{
       url = local_host + `/api/v2/user_modules/update_action/${formValues.action_id}/`;
      }
      fetch(url, {method: 'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(formValues)
    }).then((result)=>{
      result.json().then((resp)=>{
        console.log(resp);
        if(resp.message === 'updated successfully' || resp.message === 'created successfully'){
          const url = local_host + `/api/v2/user_modules/all_actions/`;
          makeapicall(url);
          setFormCreate(true);
          setFormValues({
            action_id: "",action_name: "",action_category: "",action_description: "",action_details: "",restapi_address: "",task: "" });
        }
      })
    })
  }


  useEffect(() => {
    const url = local_host + `/api/v2/user_modules/all_actions/`;
    makeapicall(url);
  },[]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EditActions = ({row}) =>{
    setFormCreate(false);
    setFormValues({action_id:row.action_id,action_name: row.action_name,action_category:row.action_category,action_description: row.action_description,action_details: row.action_details,restapi_address: row.restapi_address,task: row.task });
  };

const DeleteActions = ({row}) =>{
  console.log('id'+row.action_id);
  axios.delete(local_host + `/api/v2/user_modules/delete_actions/${row.action_id}/`)  
      .then(res => {  
        console.log(res);  
        console.log(res.data);  
        const url = `http://127.0.0.1:8000/api/v2/user_modules/all_actions/`;
        makeapicall(url);
        
  });
};

  return (
    <>
    <form  onSubmit={handleSubmit} style={{justifyContent:'center', marginBottom:'2em'}}>
      
        <div className="form-inline row">
          <div className="form-group col-md-3 mb-2">
            <label className="label1 mb-1">Action Id </label>
            <div className="input_group">
              <input type="text" name="action_id" className="resource_input" value={formValues && formValues.action_id || ""} disabled={true} /><br /> <br />
            </div>
          </div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Action Name </label>
          <div className="input_group">
          <input type="text" name="action_name" className="resource_input" value={formValues && formValues.action_name || ""} onChange={e => handleChange(e)} /><br /> <br />
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Action desc </label>
          <div className="input_group">
          <input type="text" name="action_description" className="resource_input" value={formValues && formValues.action_description || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Action details </label>
          <div className="input_group">
          <input type="text" name="action_details" className="resource_input" value={formValues && formValues.action_details || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Restapi address </label>
          <div className="input_group">
          <input type="text" name="restapi_address" className="resource_input" value={formValues && formValues.restapi_address || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Action Category </label>
          <div className="input_group">
          <input type="text" name="action_category" className="resource_input" value={formValues && formValues.action_category || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Task </label>
          <div className="input_group">
          <input type="text" name="task" className="resource_input" value={formValues && formValues.task || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
        </div>
      
      <div className="button-section">  
      {formCreate ? <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff",}}>Create</Button>:
        <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff"}}>Save</Button>}
      </div>
  </form>

    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 240 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow style={{backgroundColor: 'rgb(238,228,249)'}}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  class="header_column"
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
                    
            {rowdata && rowdata
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell className="cell_data"> {row.action_id}</TableCell>
                    <TableCell className="cell_data"> {row.action_name}</TableCell>
                    <TableCell className="cell_data"> {row.action_description}</TableCell>
                    <TableCell className="cell_data"> {row.action_details}</TableCell>
                    <TableCell className="cell_data"> {row.restapi_address}</TableCell>
                    <TableCell className="cell_data"> {row.action_category}</TableCell>
                    <TableCell className="cell_data"> {row.task}</TableCell>
                    <TableCell className="cell_data">
                        <span onClick={e => EditActions({row})}><i class='fa-solid fa-pen-to-square' ></i></span> 
                        <span style={{marginLeft:'1em'}} onClick={e => DeleteActions({row})}><i class='fas fa-trash'></i></span>  
                    </TableCell>
                  </TableRow>
                );
              })}
                           
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={rowdata?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
  );
}

const StickyHeadTable2 = ({data}) => {
  const [page, setPage] = useState(0);
  const [rowdata, setRowdata] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formCreate, setFormCreate] = useState(true);
  const [formValues, setFormValues] = useState({
  job_id: "",job_name: "",job_category: "",job_description: "", process:'' })

  let handleChange = (e) => {
      setFormValues({
        ...formValues,
        [e.target.name]: e.target.value
        })
    }
  
    const makeapicall = async (url) => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log('data'+data);
        setRowdata(data); 
        
      }
      catch (e) {
        console.log(e);
     
      }
    }
  
  let handleSubmit = (event) => {
      event.preventDefault();
      let url;
      if(formCreate == true){
        url = local_host + `/api/v2/user_modules/createjob/`;
      }else{
       url = local_host + `/api/v2/user_modules/updatejob/${formValues.job_id}/`;
      }
      fetch(url, {method: 'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(formValues)
    }).then((result)=>{
      result.json().then((resp)=>{
        console.log(resp);
        if(resp == 'updated successfully' || resp == 'created successfully'){
          const url = local_host + `/api/v2/user_modules/job_details/`;
          makeapicall(url);
          setFormCreate(true);
          setFormValues({
            job_id: "",job_name: "",job_category: "",job_description: "", process:'' });
        }
      })
    })
  }


  useEffect(() => {
    const url = local_host + `/api/v2/user_modules/job_details/`;
    makeapicall(url);
  },[]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const EditActions = ({row}) =>{
    setFormCreate(false);
    setFormValues({job_id:row.job_id,job_name: row.job_name,job_category:row.job_category,job_description: row.job_description, process: row.process });
  };

const DeleteActions = ({row}) =>{
  console.log('id'+row.job_id);
  axios.delete(local_host + `/api/v2/user_modules/deletejob/${row.job_id}/`)  
      .then(res => {  
        console.log(res);  
        console.log(res.data);  
        const url = local_host + `/api/v2/user_modules/job_details/`;
        makeapicall(url);
        
  });
};

  return (
    <>
    <form  onSubmit={handleSubmit} style={{justifyContent:'center', marginBottom:'2em'}}>
      
        <div className="form-inline row">
          <div className="form-group col-md-3 mb-2">
            <label className="label1 mb-1">Job Id </label>
            <div className="input_group">
              <input type="number" name="job_id" className="resource_input" value={formValues && formValues.job_id || ""} disabled={true} /><br /> <br />
            </div>
          </div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Job Name </label>
          <div className="input_group">
          <input type="text" name="job_name" className="resource_input" value={formValues && formValues.job_name || ""} onChange={e => handleChange(e)} /><br /> <br />
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Job desc </label>
          <div className="input_group">
          <input type="text" name="job_description" className="resource_input" value={formValues && formValues.job_description || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Job category </label>
          <div className="input_group">
          <input type="text" name="job_category" className="resource_input" value={formValues && formValues.job_category || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Process</label>
          <div className="input_group">
          <input type="number" name="process" className="resource_input" value={formValues && formValues.process || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <br /><br/>
        </div>
      
      <div className="button-section">  
      {formCreate ? <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff"}}>Create</Button>:
        <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff"}}>Save</Button>}
      </div>
  </form>

    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 240 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow style={{backgroundColor: 'rgb(233, 232, 217)'}}>
              {columns2.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  class="header_column"
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
                    
            {rowdata && rowdata
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell className="cell_data"> {row.job_id}</TableCell>
                    <TableCell className="cell_data"> {row.job_name}</TableCell>
                    <TableCell className="cell_data"> {row.job_description}</TableCell>
                    <TableCell className="cell_data"> {row.job_category}</TableCell>
                    <TableCell className="cell_data"> {row.process}</TableCell>
                    <TableCell className="cell_data">
                        <span onClick={e => EditActions({row})}><i class='fa-solid fa-pen-to-square' ></i></span> 
                        <span style={{marginLeft:'1em'}} onClick={e => DeleteActions({row})}><i class='fas fa-trash'></i></span>  
                    </TableCell>
                  </TableRow>
                );
              })}
                           
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={rowdata?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
  );
}



const StickyHeadTable3 = ({data}) => {
  const [page, setPage] = useState(0);
  const [rowdata, setRowdata] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formCreate, setFormCreate] = useState(true);
  const [formValues, setFormValues] = useState({
    task_id: "",task_name: "",task_description: "",task_category: "",job: "" })

  let handleChange = (e) => {
      setFormValues({
        ...formValues,
        [e.target.name]: e.target.value
        })
    }
  
    const makeapicall = async (url) => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log('data'+data);
        setRowdata(data); 
        
      }
      catch (e) {
        console.log(e);
     
      }
    }
  
  let handleSubmit = (event) => {
      event.preventDefault();
      let url;
      if(formCreate == true){
        url = local_host + `/api/v2/user_modules/create_task/`;
      }else{
       url = local_host + `/api/v2/user_modules/update_task/${formValues.task_id}/`;
      }
      fetch(url, {method: 'POST',
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(formValues)
    }).then((result)=>{
      result.json().then((resp)=>{
        console.log(resp);
        if(resp.message === 'updated successfully' || resp.message === 'created successfully'){
          const url = local_host + `/api/v2/user_modules/all_task/`;
          makeapicall(url);
          setFormCreate(true);
          setFormValues({
            task_id: "",task_name: "",task_description: "",task_category: "",job: "" });
        }
      })
    })
  }


  useEffect(() => {
    const url = local_host + `/api/v2/user_modules/all_task/`;
    makeapicall(url);
  },[]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EditTasks = ({row}) =>{
    setFormCreate(false);
    setFormValues({task_id:row.task_id,task_name: row.task_name,task_description: row.task_description,task_category: row.task_category, job: row.job });
  };

const DeleteTasks = ({row}) =>{
  console.log('id'+row.task_id);
  axios.delete(local_host + `/api/v2/user_modules/delete_task/${row.task_id}/`)  
      .then(res => {  
        console.log(res);  
        console.log(res.data);  
        const url = local_host + `/api/v2/user_modules/all_task/`;
        makeapicall(url);
        
  });
};

  return (
    <>
    <form  onSubmit={handleSubmit} style={{justifyContent:'center', marginBottom:'2em'}}>
      
        <div className="form-inline row">
          <div className="form-group col-md-3 mb-2">
            <label className="label1 mb-1">task_id</label>
            <div className="input_group">
              <input type="number" name="task_id" className="resource_input" value={formValues && formValues.task_id || ""} disabled={true} /><br /> <br />
            </div>
          </div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">task_name </label>
          <div className="input_group">
          <input type="text" name="task_name" className="resource_input" value={formValues && formValues.task_name || ""} onChange={e => handleChange(e)} /><br /> <br />
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">task_description </label>
          <div className="input_group">
          <input type="text" name="task_description" className="resource_input" value={formValues && formValues.task_description || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">task_category </label>
          <div className="input_group">
          <input type="text" name="task_category" className="resource_input" value={formValues && formValues.task_category || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">job </label>
          <div className="input_group">
          <input type="number" name="job" className="resource_input" value={formValues && formValues.job || ""} onChange={e => handleChange(e)} /><br /><br/>
          </div></div>
          
        </div>
      
      <div className="button-section">  
      {formCreate ? <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff"}}>Create</Button>:
        <Button variant="contained" type="submit" style={{backgroundColor: "#000055", color: "#ffffff"}}>Save</Button>}
      </div>
  </form>

    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 240 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow style={{backgroundColor: 'rgb(233, 232, 217)'}}>
              {columns3.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  class="header_column"
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
                    
            {rowdata && rowdata
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell className="cell_data"> {row.task_id}</TableCell>
                    <TableCell className="cell_data"> {row.task_name}</TableCell>
                    <TableCell className="cell_data"> {row.task_description}</TableCell>
                    <TableCell className="cell_data"> {row.task_category}</TableCell>
                    
                    <TableCell className="cell_data"> {row.job}</TableCell>
                    <TableCell className="cell_data">
                        <span onClick={e => EditTasks({row})}><i class='fa-solid fa-pen-to-square' ></i></span> 
                        <span style={{marginLeft:'1em'}} onClick={e => DeleteTasks({row})}><i class='fas fa-trash'></i></span>  
                    </TableCell>
                  </TableRow>
                );
              })}
                           
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={rowdata?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
  );
}


const ResourceMasterTabs = () => {
  const [value, setValue] = useState("1");
  const [rowData, setRowData] = useState(undefined);
 
  const [hideResultGrid, setHideResultGrid] = useState(true);
  const [tab, setTab] = useState(null);
  
  const makeAPICall = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log('data'+data);
      setRowData(data);
      setHideResultGrid(false);
      // setColumnData(gridColumnDefs);
      
    }
    catch (e) {
      console.log(e);
      setHideResultGrid(true);
    }
  }
 
  const handleChange = (event, newValue) => {
    console.log('newValue'+newValue);
    let url='';
    switch(newValue){
      case 0:
        url = local_host + `/api/v2/user_modules/action/${1}`;
        makeAPICall(url);
        break;
      case 1:
        url = local_host + `/api/v2/user_modules/action/${1}`;
        makeAPICall(url);
        break;
      case 2:
        url = local_host + `/api/v2/user_modules/job_details/`;
        makeAPICall(url);
        break;
      default:
        break;
    }
    setValue(newValue);
  };

  return (
    
    <Box>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", display: 'flex', justifyContent: 'flex-end'}}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" >
            <Tab label="Action" value="1" className="resource_input"/>
            <Tab label="Task" value="2" sx={{color:'darkblue'}} />
            <Tab label="Job" value="3" sx={{color:'darkblue'}} />
            <Tab label="Job Execution" value="4" sx={{color:'darkblue'}} />
          </TabList>
        </Box>
        <TabPanel value="1" style={{backgroundColor:'white'}}><StickyHeadTable data={rowData}/></TabPanel>
        <TabPanel value="2" style={{backgroundColor:'white'}}><StickyHeadTable3 data={rowData}/></TabPanel>
        <TabPanel value="3" style={{backgroundColor:'white'}}><StickyHeadTable2 data={rowData}/></TabPanel>
        <TabPanel value="4" style={{backgroundColor:'white'}}><FilesConsolidation /></TabPanel>
      </TabContext>
    </Box>
    
  );
}



const ResourceMaster = () => {
 
  return (
    
     <div className="side" style={{ padding:"10px"}}>
     <Grid columns='equal'>
          <Grid.Row style={{ backgroundColor:"#fff",borderRadius:"12px",marginTop:"10px"}}>
          <Grid.Column>
              <ResourceMasterTabs />
          </Grid.Column>
          </Grid.Row> 
      </Grid>
     </div>
    
  );
}


export default ResourceMaster;